import PropTypes from "prop-types";
import * as React from "react";

import { translate } from "react-i18next";
import { Button, ButtonGroup, DialogContainer, DialogHeader, DialogBody, DialogFooter } from "@wg/wows-react-uikit";

import ClanBattlesInfoPage from "../../ViewClanBattles/ClanBattlesInfoPage/ClanBattlesInfoPage";

const propTypes = {
  clanBattlesInfoContent: PropTypes.object,
  hideDialog: PropTypes.func,
  openBattlesInfoUrl: PropTypes.func,

  t: PropTypes.func.isRequired
};

class BattleInfoDialog extends React.PureComponent {

  render() {
    const t = this.props.t;
    const content = this.props.clanBattlesInfoContent;

    if (!content) {
      return null;
    }

    const clansBattlesInfoContent = content.clanBattlesPage || {};
    const clanBattlesInfoUrl = clansBattlesInfoContent.more_link || '';
    const clanBattlesInfoText = clansBattlesInfoContent.more_link_title || '';
    const clanBattlesInfoButton = clanBattlesInfoUrl && clanBattlesInfoText ? <Button onClick={this.props.openBattlesInfoUrl}>
                {t('Подробнее')}
            </Button> : null;

    return <DialogContainer>
                <DialogHeader>{clansBattlesInfoContent.main_title || ''}</DialogHeader>
                <DialogBody>
                    <ClanBattlesInfoPage contentInfo={content} />
                </DialogBody>
                <DialogFooter>
                    <ButtonGroup>
                        {clanBattlesInfoButton}
                        <Button onClick={this.props.hideDialog}>
                            {t('Закрыть')}
                        </Button>
                    </ButtonGroup>
                </DialogFooter>
            </DialogContainer>;
  }
}

BattleInfoDialog.propTypes = propTypes;

export default translate()(BattleInfoDialog);